// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/webpack/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".badge[data-v-1016759a]{text-transform:uppercase;padding:.3rem .5rem;font-size:1.2rem;border-radius:.4rem}", ""]);
// Exports
module.exports = exports;
